import React from "react";

export default function SearchResult({
  title, url, excerpt, number, parentPage
}) {
  const sanatisedExcerpt = excerpt
    .replace(/website\r\nsummary\r\n/g, "")
    .replace(/website summary/g, "");

  const showParentPage = parentPage !== "";
  return (
    <div className="col-12">
      <a href={url} target="_self">
        <div
          className="search-listing"
          style={{
            animationDelay: `${number * 0.2}s`
          }}
        >
          <div className="main">
            {showParentPage ? (
              <h3>{parentPage}: {title}</h3>
            ) : (
              <h3>{title}</h3>
            )}
            {showParentPage
              && <small>in {parentPage}</small>
            }
            {excerpt && (
              <p
                className="teaser"
                dangerouslySetInnerHTML={{
                  __html: sanatisedExcerpt
                }}
              ></p>
            )}
          </div>
          <p className="btn-primary">View details</p>
        </div>
      </a>
    </div>
  );
}
